const sourceMatrixTypes = {
    MONO: 0,
    STEREO: 1,
    STEREO_IN_MONO_OUT: 2,
    FLEX: 3
}

export {
    sourceMatrixTypes
}
